import React from 'react';

import { useTranslation } from 'next-i18next/pages';

import { Button } from 'antd';
import cn from 'classnames';

import { Container } from '@//components/common';
import { InstallPwa } from '@/components/InstallPwa/InstallPwa';
import {
	KATALOG_URL,
	PERSONAL_ACCOUNT_FISH_PRODUCTS_URL,
	STORAGE_SEARCH_URL,
} from '@/constants/routes';
import { TranslationNamespace } from '@/i18n';

import { BuyIcon, GetToStorageIcon, SaleIcon, StorageIcon } from './icons';

import styles from './HeroHeader.module.scss';

export default function HeroHeader() {
	const t = useTranslation(TranslationNamespace.Marketing).t;
	const services = getServices(t);

	return (
		<section className={cn(styles.section)}>
			<Container className={styles.container}>
				<h1 className={styles.title}>
					{t('main-landing.hero.fishplace-operating-system-for-storing')}
					<br />
					{t('main-landing.hero.and-wholesale-trading-in-fish-and-seafood')}
				</h1>

				<p className={styles.subtitle}>
					{t(
						'main-landing.hero.we-automate-sales-logistics-and-retention-management-helping-fish-compan',
					)}
				</p>

				<ul className={styles.list}>
					{services.map((service, index) => (
						<li key={index} className={styles.card}>
							<div className={styles.iconContainer}>
								<svg
									className={styles.iconBackground}
									width="7.6rem"
									height="7rem"
									viewBox="0 0 76 70"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M6.79926 51.7437C-7.87806 26.3219 6.91988 4.23814 27.8281 -7.83323C48.7363 -19.9046 72.9325 -13.7101 84.7415 6.74373C96.5506 27.1976 84.1743 55.4754 70.0704 63.6183C49.1622 75.6897 15.1811 66.2616 6.79926 51.7437Z"
										fill="#ECF3FD"
									/>
								</svg>
								{service.icon}
							</div>
							<h3 className={styles.serviceTitle}>{service.title}</h3>
							<p className={styles.serviceDescription}>{service.description}</p>
							<Button type="primary" block className={styles.link} href={service.link}>
								{service.buttonText}
							</Button>
						</li>
					))}
				</ul>
				<InstallPwa />
			</Container>
		</section>
	);
}

const getServices = (t: ReturnType<typeof useTranslation>['t']) => [
	{
		title: <span>{t('main-landing.hero.store')}</span>,
		description: t('main-landing.hero.store-description'),
		link: STORAGE_SEARCH_URL,
		icon: <StorageIcon />,
		buttonText: t('main-landing.hero.find-warehouse'),
	},
	{
		title: <span>{t('main-landing.hero.buy')}</span>,
		description: t('main-landing.hero.buy-description'),
		link: KATALOG_URL,
		icon: <BuyIcon />,
		buttonText: t('main-landing.hero.buy-fish'),
	},
	{
		title: <span>{t('main-landing.hero.trade')}</span>,
		description: t('main-landing.hero.trade-description'),
		link: PERSONAL_ACCOUNT_FISH_PRODUCTS_URL,
		icon: <SaleIcon />,
		buttonText: t('main-landing.hero.sell-fish'),
	},
	{
		title: <span>{t('main-landing.hero.automate-warehouse')}</span>,
		description: t('main-landing.hero.automate-description'),
		link: '/avtomatizaciya-kommunikacii-s-klientami',
		icon: <GetToStorageIcon />,
		buttonText: t('main-landing.hero.add-warehouse'),
	},
];
